import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled.div(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
  }),
);

export const InfoWrapper = styled.dl(() =>
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      '32px 64px',
      '32px 64px',
    ],
  }),
);

export const ButtonWrapper = styled.div(() =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    margin: `${defaultTheme.spacing.s} 0 40px`,
  }),
);

export const TermName = styled.dt(() =>
  mq({
    display: 'flex',
    flexDirection: 'column',
    fontSize: [
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
      defaultTheme.font.size.l,
      defaultTheme.font.size.l,
    ],
    fontWeight: 'bold',
    borderBottom: `1px solid ${defaultTheme.border.color.black}`,
    paddingBottom: defaultTheme.spacing.l,
  }),
);

export const Hiragana = styled.span(() =>
  mq({
    display: 'inline-block',
    color: defaultTheme.text.time,
    fontSize: defaultTheme.font.size.xs,
    fontWeight: 'normal',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const Description = styled.dd(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    marginTop: defaultTheme.spacing.l,
  }),
);
